import {
  DEFAULT_SIDER_WIDTH as CORE_DEFAULT_SIDER_WIDTH,
  getStoredSiderWidth as getCoreStoredSiderWidth,
  MAX_SIDER_WIDTH,
  MIN_SIDER_WIDTH,
  SIDER_WIDTH_STORAGE_KEY,
  SiderResizeHandle,
} from '@zhiyue/core';

export const DEFAULT_SIDER_WIDTH = 200;

export const getStoredSiderWidth = () => {
  const stored = getCoreStoredSiderWidth();
  return stored === CORE_DEFAULT_SIDER_WIDTH ? DEFAULT_SIDER_WIDTH : stored;
};

export {
  MAX_SIDER_WIDTH,
  MIN_SIDER_WIDTH,
  SIDER_WIDTH_STORAGE_KEY,
};

export default SiderResizeHandle;
